import React, { useEffect, useState, useMemo } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, Dialog, IconButton, Switch, Typography } from "@mui/material";
import { masterAPI } from "../dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import {useSelector} from "react-redux"
import {
    EditOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";

import RolesModal from "./RolesModal";

const Roles = () => {
    const actionsAllow=useSelector(state=>state.dataRed.actionsAllow)

    const [isLoading, setIsLoading] = useState(false);
    const [create, setCreate] = useState(false);
    const [mode, setMode] = useState("");
    const [editData, setEditData] = useState({});
    const [filterValue,setFilterValue]=useState("enableData")
    const [backUpData,setBackUpData]=useState([])


    useEffect(() => {
        getData();
    }, []);

    const getData = async() => {
        setIsLoading(true);
        const link = masterAPI["roles"].link;
        await axiosPrivate
            .get(`${link}`)
            .then((res) => {
                console.log(res.data.result, "rolesresult");
                setBackUpData(res.data.result);
                setIsLoading(false);

            })
            .catch((e) => {
                console.log(e, "roles");
                setIsLoading(false);
                setBackUpData([])
            });

        setIsLoading(false);
    };

    const handleButtonNew = () => {
        setMode("Create");
        setCreate(true);
    };
    const handleCreateClose = () => {
        setMode("");
        setCreate(false);
        getData();
    };

    const handleEdit = (data) => {
        setEditData(data);
        setMode("Edit");
        setCreate(true);
    };

    // const handleDelete = (id) => {
    //   const deleteLink = masterAPI["roles"].delete;
    //   axiosPrivate
    //     .delete(`${deleteLink}/${id}`)
    //     .then((res) => {
    //       console.log(res.data);
    //       getData();
    //     })
    //     .catch((e) => {
    //       console.log(e, "delete roles");
    //     });
    // };

    const handleDelete = async(e,id) => {
        const enableLink = masterAPI["roles"].enable;
        const disableLink = masterAPI["roles"].disable;
        if(e.target.checked){
            await axiosPrivate
                .put(`${enableLink}/${id}`)
                .then((res) => {
                    console.log(res.data);
                    getData();
                })
                .catch((e) => {
                    console.log(e, "enable ");
                });
        }else{
            await axiosPrivate
                .put(`${disableLink}/${id}`)
                .then((res) => {
                    console.log(res.data);
                    getData();
                })
                .catch((e) => {
                    console.log(e, "disable ");
                });
        }
    };

    const columns = [
        {
            accessor: "id",
            disableFilters: true,
            Cell: () => {
                return (
                    <Box sx={{width:color.checkBoxWidth }}>
                        <Checkbox
                            // icon={<RadioButtonUncheckedOutlined />}
                            // checkedIcon={<CheckCircle />}
                        />
                    </Box>
                );
            },
        },
        // {
        //   Header: "Code",
        //   accessor: "code",
        //   // disableFilters: true,
        // },
        {
            Header: "Name",
            accessor: "name",
            // disableFilters: true,
        },

        {
            Header: "Actions",
            Cell: ({ cell }) => {
                // console.log(cell)
                return (
                    <Box sx={{ whiteSpace: "nowrap" }}>
                        <IconButton disabled={!actionsAllow.edit}>
                            <EditOutlined
                                onClick={() => {
                                    handleEdit(cell.row.original);
                                }}
                                sx={{
                                    fontSize: color.masterEditDelButton,
                                    color: actionsAllow.edit? color.masterEditDelButtonColor:"default",
                                }}
                            />
                        </IconButton>
                        {/* <IconButton disabled={!actionsAllow.delete}>
              <DeleteOutline
                onClick={() => {
                  handleDelete(cell.row.original.id);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.delete? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton> */}
                        <Switch
                            disabled={!actionsAllow.delete}
                            checked={cell.row.original.isActive}
                            onChange={(e)=>{handleDelete(e,cell.row.original.id)}}

                        />
                    </Box>
                );
            },
        },
    ];

    const handleChangeFilter=(e)=>{
        setFilterValue(e)
    }

    // Client-side filtering using useMemo
    const filteredData = useMemo(() => {
        if (filterValue === "showAll") {
            return backUpData;
        } else if (filterValue === "enableData") {
            return backUpData.filter(item => item.isActive === true);
        } else if (filterValue === "disableData") {
            return backUpData.filter(item => item.isActive === false);
        }
        return backUpData;
    }, [backUpData, filterValue]);

    return (
        <>
            <Box>
                <Typography
                    sx={{
                        color: color.masterPageTitleColor,
                        fontSize: color.masterPageTitleFontSize,
                        fontWeight: color.masterPageTitleFontWeight,
                        mb: color.masterPageTitlemd,
                    }}
                >
                    {masterAPI["roles"].title}
                </Typography>
            </Box>

            <TableContainer
                columns={columns}
                data={filteredData}
                buttonNew={handleButtonNew}
                loading={isLoading}
                buttonDisable={!actionsAllow.create}
                filterValue={filterValue}
                handleChange={handleChangeFilter}
                filterShow={true}
            />


            <Dialog
                open={create}
                onClose={handleCreateClose}
                maxWidth={"md"}
                children={
                    <RolesModal
                        handleCloseClick={handleCreateClose}
                        mode={mode}
                        editData={editData}
                    />
                }
            />
        </>
    );
};

export default Roles;

